var AdaptiveImage = require("../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "static/media/radio_button_default.69d986fc.png","uri@2x": __webpack_public_path__ + "static/media/radio_button_default.357d40fa.png","uri@3x": __webpack_public_path__ + "static/media/radio_button_default.ffd8cc88.png",
    width: 20,
    height: 20
});